// Module
var code = "<script>let $ctrl</script> <molecule-form-edit save=\"$ctrl.save\"> <organ-edit-panel-user-admin admin-user=\"$ctrl.userData.adminUser\" cancel-callback-function=\"$ctrl.resetUserEditAdmins\" own-password=\"$ctrl.passwordOwn\" panel-right-settings=\"$ctrl.panelRightAdminSettings\"></organ-edit-panel-user-admin> </molecule-form-edit> ";
// Exports
module.exports = code;